import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Header2 = (props: Props) => {
  const className = `font-jost-medium text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl ${mapStylesFromProps(
    props
  )}`
  return <span className={className}>{props.children}</span>
}

export default Header2
